const en = {
    form: require('./en/form.json'),
    general: require('./en/general.json'),
    pagination: require('./en/pagination.json'),
    auth: require('./en/auth.json'),
    dashboard: require('./en/pages/dashboard.json'),
    user: require('./en/entities/user.json'),
    data: require('./en/data.json'),
    date: require('./en/date.json'),
    location: require('./en/location.json'),
    country: require('./en/country.json'),
    permission: require('./en/permission.json'),
    actual: require('./en/entities/actual.json'),
    budget: require('./en/entities/budget.json'),
    'budget-projection': require('./en/entities/budget-projection.json'),
    company: require('./en/entities/company.json'),
    extrapolation: require('./en/entities/extrapolation.json'),
    'profit_and_loss': require('./en/entities/profit_and_loss.json'),
    projection: require('./en/entities/projection.json'),
    store: require('./en/entities/store.json'),
    import: require('./en/entities/import.json'),
    review: require('./en/entities/review.json'),
    storemanager: require('./en/storemanager.json'),
    formula: require('./en/formula.json'),
    evaluation: require('./en/pages/evaluation.json'),
};

const de = {
    form: require('./de/form.json'),
    general: require('./de/general.json'),
    pagination: require('./de/pagination.json'),
    auth: require('./de/auth.json'),
    dashboard: require('./de/pages/dashboard.json'),
    user: require('./de/entities/user.json'),
    data: require('./de/data.json'),
    date: require('./de/date.json'),
    location: require('./de/location.json'),
    country: require('./de/country.json'),
    permission: require('./de/permission.json'),
    actual: require('./de/entities/actual.json'),
    budget: require('./de/entities/budget.json'),
    'budget-projection': require('./de/entities/budget-projection.json'),
    company: require('./de/entities/company.json'),
    extrapolation: require('./de/entities/extrapolation.json'),
    'profit_and_loss': require('./de/entities/profit_and_loss.json'),
    projection: require('./de/entities/projection.json'),
    store: require('./de/entities/store.json'),
    import: require('./de/entities/import.json'),
    review: require('./de/entities/review.json'),
    storemanager: require('./de/storemanager.json'),
    formula: require('./de/formula.json'),
    evaluation: require('./de/pages/evaluation.json'),
};

export default {en, de};
